import { getWindowConfig } from '../config';

export const AUTH_API = () => getWindowConfig().apiService + 'auth';
export const AUTH_LOGIN_API = () => getWindowConfig().apiService + 'auth/login';

export const APPS_API = () => getWindowConfig().apiService + 'apps/';

export const LOOKUP_ITEM_API = () =>
  getWindowConfig().apiService + 'lookuplistitem';
export const LOOKUP_ITEM_DELETEWITHCHECK_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/deleteWithCheck';
export const LOOKUP_ITEM_KHUCUMCN_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/1';
export const LOOKUP_ITEM_THAMQUYENQLMT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/2';
export const LOOKUP_ITEM_TYPE_INSPECTION_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/3';
export const LOOKUP_ITEM_TYPE_AUDIT_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/30';
export const LOOKUP_ITEM_QUANHUYEN_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/4';
export const LOOKUP_ITEM_EMISSIONTYPE_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/6';
export const LOOKUP_ITEM_MUCDICH_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/8';
export const LOOKUP_ITEM_TINHTRANG_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/9';
export const LOOKUP_ITEM_TINHTRANG_THANHTRA_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/29';
export const LOOKUP_ITEM_SUKIENTUANTHU_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/7';
export const LOOKUP_ITEM_PERMITTYPE_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/10';
export const LOOKUP_ITEM_NGANHNGHE_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/12';
export const LOOKUP_ITEM_DEVICE_STAGE_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/DeviceStage';

export const LOOKUP_ITEM_HINHTHUCSOHUU_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/20';
export const LOOKUP_ITEM_NGUONNUOC_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/25';
export const LOOKUP_ITEM_LOAIHOSO_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/27';
export const LOOKUP_ITEM_HOACHAT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/29';
export const LOOKUP_ITEM_GETALL_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/getAll';
export const LOOKUP_ITEM_UPDATE_CHILDREN_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/updateChildren';

export const LOOKUP_ITEM_TYPE_DEVICE_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/DeviceFileType';
export const LOOKUP_ITEM_TYPE_PERMIT_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/15';
export const LOOKUP_ITEM_TYPE_EIA_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/17';
export const LOOKUP_ITEM_TYPE_FACILITY_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/19';
export const LOOKUP_ITEM_TYPE_BIODIVERSITY_ATTACHMENT_API = () =>
  getWindowConfig().apiService +
  'lookuplistitem/lookuplist/BiodiversityAttachment';

export const LOOKUP_ITEM_BPTGCTNH_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/28'; //bộ phận thu gom chất thải nguy hại
export const LOOKUP_ITEM_NGUONTHAI_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/31';
export const LOOKUP_ITEM_NGUONTHAI_2_API = () =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/32';
export const LOOKUP_ITEM_LIST_API = (lookupListId) =>
  getWindowConfig().apiService + 'lookuplistitem/lookuplist/' + lookupListId;

export const LOOKUPLIST_API = () => getWindowConfig().apiService + 'lookuplist';
export const LOOKUP_LIST_DELETEWITHCHECK_API = () =>
  getWindowConfig().apiService + 'lookuplist/deleteWithCheck';
export const LOOKUPLIST_GETALL_API = () =>
  getWindowConfig().apiService + 'lookuplist/getAll';
export const LOOKUP_LIST_CHEMISTRY_API = () =>
  getWindowConfig().apiService + 'lookuplist/chemistry';

export const BIODIVERSITY_API = () =>
  getWindowConfig().apiService + 'biodiversity';
export const BIODIVERSITY_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'biodiversityAttachment';

export const SPECIES_API = () => getWindowConfig().apiService + 'species';
export const AREA_API = () => getWindowConfig().apiService + 'area';

export const COSO_API = () => getWindowConfig().apiService + 'facility';
export const COSO_CHECK_FACILITYCODE_API = () =>
  getWindowConfig().apiService + 'facility/checkFacilityCodeExist';
export const COSO_GETALL_API = () =>
  getWindowConfig().apiService + 'facility/getAll';
export const COSO_GETALL_LOCATION_API = () =>
  getWindowConfig().apiService + 'facility/get-location';

export const COSO_EXPORT_API = () =>
  getWindowConfig().apiService + 'facility/export';
export const COSO_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facility/exportWithQuery';

export const INSPECTION_API = () =>
  getWindowConfig().apiService + 'facilityInspection';
export const INSPECTION_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'inspectionAttachment';
export const INSPECTION_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityInspection/getAll';
export const INSPECTION_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilityInspection/export';
export const INSPECTION_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityInspection/exportWithQuery';

export const FACILITY_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'facilityattachment';
export const EIA_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'eiaattachment';

export const FACILITYEIA_API = () =>
  getWindowConfig().apiService + 'facilityeia';
export const FACILITYEIA_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityeia/getAll';
export const FACILITYEIA_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityeia/exportWithQuery';

export const UPLOAD_FILE_API = () =>
  getWindowConfig().apiService + 'file/upload';

export const FACILITYPERMIT_API = () =>
  getWindowConfig().apiService + 'facilitypermit';
export const FACILITYPERMIT_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilitypermit/export';
export const FACILITYPERMIT_GETALL_API = () =>
  getWindowConfig().apiService + 'facilitypermit/getAll';
export const FACILITYPERMIT_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilitypermit/exportWithQuery';
export const PERMIT_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'permitattachment';

// Thiet bi
export const FACILITY_DEVICE_API = () =>
  getWindowConfig().apiService + 'facilityDevice';
export const FACILITY_DEVICE_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilityDevice/export';
export const FACILITY_DEVICE_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityDevice/getAll';
export const FACILITY_DEVICE_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityDevice/exportWithQuery';
export const FACILITY_DEVICE_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'deviceAttachment';

export const FACILITYEMISSION_API = () =>
  getWindowConfig().apiService + 'facilityemission';
export const FACILITYEMISSION_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilityemission/export';
export const FACILITYEMISSION_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityemission/getAll';
export const FACILITYEMISSION_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityemission/exportWithQuery';

export const FACILITYENVIPROTECTFEE_API = () =>
  getWindowConfig().apiService + 'facilityEnviProtectFee';
export const FACILITYENVIPROTECTFEE_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilityEnviProtectFee/export';
export const FACILITYENVIPROTECTFEE_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityEnviProtectFee/getAll';
export const FACILITYENVIPROTECTFEE_EXPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityEnviProtectFee/exportWithQuery';

export const FACILITYENVIMONITORINGREPORT_API = () =>
  getWindowConfig().apiService + 'facilityEnviMonitoringReport';
export const FACILITYENVIMONITORINGREPORT_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilityEnviMonitoringReport/export';
export const FACILITYENVIMONITORINGREPORT_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityEnviMonitoringReport/getAll';
export const FACILITYENVIMONITORINGREPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityEnviMonitoringReport/exportWithQuery';

export const MONITORING_API = () => getWindowConfig().apiService + 'monitoring';
export const MONITORING_SOLIEUMOINHAT_API = () =>
  getWindowConfig().apiService + 'monitoring/solieumoinhat';

export const FACILITY_HAZAR_WASTE_REPORT_API = () =>
  getWindowConfig().apiService + 'facilityHazarWasteReport';
export const FACILITY_HAZAR_WASTE_REPORT_API_EXPORT_API = () =>
  getWindowConfig().apiService + 'facilityHazarWasteReport/export';
export const FACILITY_HAZAR_WASTE_REPORT_GETALL_API = () =>
  getWindowConfig().apiService + 'facilityHazarWasteReport/getAll';
export const FACILITY_HAZAR_WASTE_REPORT_WITH_IDS_API = () =>
  getWindowConfig().apiService + 'facilityHazarWasteReport/exportWithQuery';
export const FACILITY_HAZAR_WASTE_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'facilityHazarWasteAttachment';

export const USER_API = () => getWindowConfig().apiService + 'user';

export const LOG_API = () => getWindowConfig().apiService + 'log';

export const ROLE_API = () => getWindowConfig().apiService + 'role';

//Kiểm tra

export const FACILITY_AUDIT_API = () =>
  getWindowConfig().apiService + 'facility-audit';
export const FACILITY_AUDIT_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'facility-audit-attachment';

// van ban phap ly
export const LEGAL_DOCUMENT_API = () =>
  getWindowConfig().apiService + 'legal-document';
export const LEGAL_DOCUMENT_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'legal-document-attachment';

// vBC Cong tac BVMT
export const ENVIRONMENT_PROTECT_WORK = () =>
  getWindowConfig().apiService + 'environment-protection-work';
export const ENVIRONMENT_PROTECT_WORK_ATTACHMENT_API = () =>
  getWindowConfig().apiService + 'environment-protection-work-attachment';

// ROLE MODULE
export const ROLE = () => getWindowConfig().role;

// export const USER_API = () => getWindowConfig().apiService + 'monitoring/solieumoinhat'
export const TEST_ROUTE_API = () => getWindowConfig().apiService + 'testRoute';



// WEBPACK FOOTER //
// ./src/api/config.js